import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCouponRed = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .4,
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#FF5353",
				d: "M21.5996 5.49194C22.1519 5.49194 22.5996 5.93966 22.5996 6.49194V9.66577C21.4349 10.0779 20.5996 11.1861 20.5996 12.4919C20.5996 13.7977 21.4351 14.9049 22.5996 15.3171V18.4919C22.5996 19.0442 22.1519 19.4919 21.5996 19.4919H3.59961C3.04732 19.4919 2.59961 19.0442 2.59961 18.4919V15.3171C3.76413 14.9049 4.59961 13.7977 4.59961 12.4919C4.59961 11.1861 3.76429 10.0779 2.59961 9.66577V6.49194C2.59961 5.93966 3.04732 5.49194 3.59961 5.49194H21.5996Z"
			}), /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 6,
				x: 6.59961,
				y: 9.49194,
				fill: "#FEEFEF",
				rx: 2
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FF5353",
			d: "M21 4.89185C21.5523 4.89185 22 5.33956 22 5.89185V9.06567C20.8353 9.47779 20 10.586 20 11.8918C20 13.1976 20.8355 14.3048 22 14.717V17.8918C22 18.4441 21.5523 18.8918 21 18.8918H3C2.44772 18.8918 2 18.4441 2 17.8918V14.717C3.16452 14.3048 4 13.1976 4 11.8918C4 10.586 3.16468 9.47779 2 9.06567V5.89185C2 5.33956 2.44772 4.89185 3 4.89185H21Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 11.6,
			height: 5.6,
			x: 6.2,
			y: 9.09185,
			fill: "#FFB5B5",
			stroke: "#FEEFEF",
			strokeWidth: .4,
			rx: .8
		})
	]
});
const ForwardRef = forwardRef(SvgCouponRed);
export default ForwardRef;
